<template>
  <div class="container">
    <div class="g-p-30">
      <!--  tab1  -->
      <el-tabs v-model="tabNow" @tab-click="tabChange">
        <el-tab-pane label="理论考试" name="0"></el-tab-pane>
        <el-tab-pane label="线上实操考试" name="1"></el-tab-pane>
      </el-tabs>

      <!--  理论考试  -->
      <div v-if="tabNow === '0'">
        <!--  tab2  -->
        <div class="g-flex">
          <div class="g-m-t-20 g-flex tab2 g-row-between">
            <div class="tab-item" :class="{'active-row':subTabIndex === null}" @click="changeSubTab(null)">
              全部
            </div>
            <div class="tab-item" :class="{'active-row':subTabIndex === 1}" @click="changeSubTab(1)">
              已合格
            </div>
            <div class="tab-item" :class="{'active-row':subTabIndex === 0}" @click="changeSubTab(0)">
              不合格
            </div>
          </div>
        </div>
        <!--  全部  -->
        <!--  已合格和不合格只是数据的筛选，tab2切换时重新获取接口即可  -->
        <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            :data="dataList"
            border
            class="g-m-t-20"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            this.emptyText="加载失败！"
            style="width: 100%">
          <el-table-column
              prop="examName"
              width="280"
              label="考试名称">
          </el-table-column>
          <el-table-column
              prop="examTime"
              width="190"
              label="考试时间">
          </el-table-column>
          <el-table-column
              prop="score"
              label="考试成绩">
          </el-table-column>
          <el-table-column
              prop="isConformity"
              label="考试结果">
            <template slot-scope="scope">
              <p :class="{'green-text':scope.row.isConformity === 1,'orange-text':scope.row.isConformity === 2,}">
                {{scope.row.isConformity===0?"不及格":"及格"}}
              </p>
            </template>
          </el-table-column>
          <el-table-column
              width="220"
              label="操作">
            <template slot-scope="scope">
              <div class="g-flex g-font-14 g-row-center g-full-width" v-if="scope.row.isConformity === 1">
                <div class="btn" @click="goPage('examination-detail',scope.row)">
                  查看答卷
                </div>
                <div class="btn2 g-m-l-20" @click="checkPaper">
                  查看证书
                </div>
              </div>
              <div class="g-flex g-font-14 g-row-center g-full-width" v-if="scope.row.isConformity === 0">
                <div class="btn" @click="goPage('examination-detail',scope.row)">
                  重新考试
                </div>
                <div class="btn2 g-m-l-20" @click="goPage('examination-detail',scope.row)">
                  查看答卷
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--  分页  -->
        <div class="g-flex g-row-center g-m-t-30">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="page.size"
              layout="prev, pager, next,sizes, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>

      <!--  线上实操考试  -->
      <div v-if="tabNow === '1'">
        <!--  tab2  -->
        <div class="g-flex">
          <div class="g-m-t-20 g-flex tab2 g-row-between">
            <div class="tab-item" :class="{'active-row':subTabIndex===null}" @click="changeOperaTab(null)">
              全部
            </div>
            <div class="tab-item" :class="{'active-row':subTabIndex === 0}" @click="changeOperaTab(0)">
              审核中
            </div>
            <div class="tab-item" :class="{'active-row':subTabIndex === 1}" @click="changeOperaTab(1)">
              已合格
            </div>
            <div class="tab-item" :class="{'active-row':subTabIndex === 2}" @click="changeOperaTab(2)">
              不合格
            </div>
          </div>
        </div>
        <!--  全部  -->
        <!--  其他状态tab2切换时重新获取接口即可  -->
        <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            :data="dataList2"
            border
            class="g-m-t-20"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            :empty-text="emptyText"
            style="width: 100%">
          <el-table-column
              prop="subject"
              width="300"
              label="考试名称">
          </el-table-column>
          <el-table-column
              prop="createTime"
              width="200"
              label="考试时间">
          </el-table-column>
          <el-table-column
              prop="status"
              label="考试结果">
            <template slot-scope="scope">
              <p :class="{'green-text':scope.row.status === 1,
                 'orange-text':scope.row.status === 2 || scope.row.status === 0}">
                <span v-if="scope.row.status===0">待审核</span>
                <span v-if="scope.row.status===1">合格</span>
                <span v-if="scope.row.status===2">不合格</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column
              width="240"
              label="操作">
            <template slot-scope="scope">
              <div class="g-flex g-font-14 g-row-center g-full-width" v-if="scope.row.status === 1">
                <div class="btn" @click="checkPaper">
                  查看证书
                </div>
                <div class="btn2 g-m-l-20" @click="showVideo(scope.row.videoPath)">
                  查看实操视频
                </div>
              </div>
              <div class="g-flex g-font-14 g-row-center g-full-width" v-if="scope.row.status === 2">
                <div class="btn" @click="goPage('examination-detail',scope.row)">
                  重新考试
                </div>
                <div class="btn2 g-m-l-20" @click="showVideo(scope.row.videoPath)">
                  查看实操视频
                </div>
              </div>
              <div class="g-flex g-font-14 g-row-center g-full-width" v-if="scope.row.status === 0">
                <div class="btn2 g-m-l-20" @click="showVideo(scope.row.videoPath)">
                  查看实操视频
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--  分页  -->
        <div class="g-flex g-row-center g-m-t-30">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page1.current"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="page1.size"
              layout="prev, pager, next,sizes, jumper"
              :total="total">
          </el-pagination>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            width="50%">
          <div class="g-rela">
            <video id="media" height="500px"  width="100%" controls>
              <source :src="videoPath" type="video/mp4">
            </video>
          </div>
          <div class="g-flex g-row-center g-m-t-30">
            <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {getMyExamList,getMyOperationList} from "@/api/education/paper";
export default {
  name: "my-exam",
  data(){
    return{
      tabNow:'0',
      dialogVisible:false,
      subTabIndex:null,
      loading:true,
      videoPath:"",
      dataList:[],
      dataList2:[],
      emptyText:"暂无数据",
      headerCellStyle:{
        backgroundColor:'#407aff',
        color:'#fff',
        textAlign:'center',
        fontSize:'16px',
      },//表头样式
      cellStyle:{
        textAlign:'center',
        fontSize:'16px',
      },//表格样式
      currentPage:1,
      page: {
        current: 1,
        size: 10
      },
      page1: {
        current: 1,
        size: 10
      },
      total:0
    }
  },
  created() {
    this.getExamList(this.subTabIndex)
  },
  methods:{
    // tab切换
    tabChange(e){
      this.tabNow = e.index;
      this.subTabIndex=null;
      this.total=0;
      if(this.tabNow*1===0){
        this.getExamList(this.subTabIndex)
      }else {
        this.getOperationList(this.subTabIndex)
      }
    },
    showVideo(videoPath){
      this.videoPath=videoPath
      this.dialogVisible=true
    },
    // tab2切换
    changeSubTab(e){
      this.subTabIndex = e;
      this.getExamList(this.subTabIndex)
    },
    changeOperaTab(e){
      this.subTabIndex = e;
      this.getOperationList(this.subTabIndex)
    },
    getExamList(status){
      this.loading=true
      this.page.status=status
      getMyExamList(this.page).then(res=>{
        this.dataList=res.records
        this.total=res.total
        this.loading=false
      },error=>{
        this.loading=false
        this.emptyText="加载失败！"
      })
    },
    getOperationList(status){
      this.loading=true
      this.page1.status=status
      getMyOperationList(this.page1).then(res=>{
        this.dataList2=res.records
        this.total=res.total
        this.loading=false
      },error=>{
        this.loading=false
        this.emptyText="加载失败！"
      })
    },
    // 跳转
    goPage(name,val){
      this.$router.push({
        name:name,
        query:{
          id:val.paperId,
          isCheck:val.status === 1,//true 查看答卷 false 重新考试
        }
      })
    },
    // 理论考试 页数切换
    handleSizeChange(val) {
      this.getExamList(this.subTabIndex)
      console.log(`每页 ${val} 条`);
    },
    // 实操考试 页数切换
    handleSizeChange1(val) {
      this.getOperationList(this.subTabIndex)
      console.log(`每页 ${val} 条`);
    },
    // 理论考试 当前页切换
    handleCurrentChange(val) {
      this.getExamList(this.subTabIndex)
      console.log(`当前页: ${val}`);
    },
    // 理论考试 当前页切换
    handleCurrentChange1(val) {
      this.getOperationList(this.subTabIndex)
      console.log(`当前页: ${val}`);
    },
    // 查看证书
    checkPaper(){
      this.$emit('checkPaper')
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    background: #fff;
    border-radius: 5px;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #333;
    font-size: 20px;
    font-weight: 500;
  }

  ::v-deep .el-tabs__item {
    color: #999;
    font-size: 20px;
    font-weight: 500;
  }

  ::v-deep .el-table--border .el-table__cell .cell{
    font-size: 14px!important;
  }

  .tab2 {
    background: #e9f2ff;
    border-radius: 15px;

    .tab-item {
      padding: 5px 21px;
      color: #407aff;
      cursor: pointer;
      font-size: 14px;
    }

    .active-row {
      border-radius: 15px;
      background: #407aff;
      color: #fff;
    }
  }

  .btn{
    padding: 3px 12px;
    background: #f6f6f8;
    border-radius: 15px;
    color: #407aff;
    cursor: pointer;
    &:hover{
      background: #407aff;
      color: #fff;
    }
  }

  .btn2{
    @extend .btn;
    color: #fff;
    background: #407aff;

    &:hover{
      color: #fff;
      background: rgba($color:#407aff,$alpha:0.8);
    }
  }

  .orange-text{
    color: #FF5918;
  }

</style>